import './input.css';
import * as cn from 'classnames';
import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { useState } from 'react';

export const Input = ({ icon, disabled = false, placeholder, onInputChanged, onClear, hasClearIcon = true }) => {
  const [inputValue, setInputValue] = useState('');

  const handleInputChanged = (e) => {
    setInputValue(e.target.value);
    onInputChanged?.(inputValue);
  };

  const handleClear = () => {
    setInputValue('');
    onClear();
  };

  return (
    <div className={cn('input-container', disabled ? 'disabled' : '', icon ? 'icon' : '')}>
      {icon && (
        <button type="submit" className="input-icon-container">
          {icon}
        </button>
      )}
      <input className="text-normal" disabled={disabled} placeholder={placeholder || ''} onChange={handleInputChanged} value={inputValue} />
      {hasClearIcon && (
        <button className={cn('input-close-icon-container', inputValue && 'show')} onClick={handleClear}>
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
